import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";

import SavingsSourcesReducer from "../slices/savingsSourcesSlice";
import expensesListsReducer from "../slices/expensesListsSlice";
import capitalOverviewReducer from "../slices/capitalOverviewSlice";
import capitalDetailsReducer from "../slices/capitalDetailsSlice";
import HomeReducer from "../slices/HomeSlice";
import sharedReducer from "../slices/sharedSlice";
import expensesReducer from "../slices/expensesSlice";
import categoriesReducer from "../slices/categoriesSlice";
import customStocksReducer from "../slices/customStocksSlice";
import profileReducer from "../slices/profileSlice";
import groupsReducer from "../slices/groupsSlice";
import encryptedNotesReducer from "../slices/encryptedNotesSlice";

import rootSaga from "../sagas";

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: {
    savingsSources: SavingsSourcesReducer,
    expensesLists: expensesListsReducer,
    capitalOverview: capitalOverviewReducer,
    home: HomeReducer,
    shared: sharedReducer,
    expenses: expensesReducer,
    capitalDetails: capitalDetailsReducer,
    categories: categoriesReducer,
    customStocks: customStocksReducer,
    profile: profileReducer,
    groups: groupsReducer,
    encryptedNotes: encryptedNotesReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ thunk: false }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export default store;
